import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import Register from './components/Register';
import AnonymousUpload from './components/AnonymousUpload';
import Dashboard from './components/Dashboard';
import UserProfile from './components/UserProfile';
import RodoPage from './components/RodoPage';
import RegulaminPage from './components/RegulaminPage';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import DemoRequest from './components/DemoRequest';
import Careers from './components/Careers';
import Blog from './components/Blog';
import Admin from './components/Admin';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { setupAxiosInterceptors } from './utils/axiosInterceptors';
import { trackPageView } from './utils/analytics';

// Setup axios interceptors for automatic token refresh
setupAxiosInterceptors();

// Track SPA route changes for analytics
const RouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
};

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  return isAuthenticated ? <>{children}</> : <Navigate to="/" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <RouteTracker />
        <div className="min-h-screen">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/upload" element={<AnonymousUpload />} />
            <Route path="/rodo" element={<RodoPage />} />
            <Route path="/regulamin" element={<RegulaminPage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/demo" element={<DemoRequest />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/blog" element={<Blog />} />
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <PrivateRoute>
                  <UserProfile />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <PrivateRoute>
                  <Admin />
                </PrivateRoute>
              } 
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
